/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_norm_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equivalent weight is the molar mass divided by the valence or number of reactive units. HCl provides one proton so its equivalent weight equals its molar mass (36.46); H2SO4 provides two, so its equivalent weight is half its molar mass.`)
};

const es_norm_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El peso equivalente es la masa molar dividida entre la valencia o el número de unidades reactivas. El HCl aporta un protón, así que su peso equivalente es igual a su masa molar (36.46); el H2SO4 aporta dos, así que su peso equivalente es la mitad de su masa molar.`)
};

const de_norm_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Äquivalentgewicht ist die molare Masse geteilt durch die Wertigkeit oder Anzahl der reaktiven Einheiten. HCl liefert ein Proton, daher entspricht sein Äquivalentgewicht seiner molaren Masse (36,46); H2SO4 liefert zwei, daher ist sein Äquivalentgewicht die Hälfte seiner molaren Masse.`)
};

const nl_norm_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equivalentgewicht is de molaire massa gedeeld door de valentie of het aantal reactieve eenheden. HCl levert één proton, dus het equivalentgewicht is gelijk aan de molaire massa (36,46); H2SO4 levert er twee, dus het equivalentgewicht is de helft van de molaire massa.`)
};

const fr_norm_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'équivalent-gramme est la masse molaire divisée par la valence ou le nombre d'unités réactives. HCl fournit un proton, donc son équivalent-gramme est égal à sa masse molaire (36,46) ; H2SO4 en fournit deux, donc son équivalent-gramme vaut la moitié de sa masse molaire.`)
};

const it_norm_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il peso equivalente è la massa molare divisa per la valenza o il numero di unità reattive. L'HCl fornisce un protone quindi il suo peso equivalente coincide con la massa molare (36,46); l'H2SO4 ne fornisce due, quindi il suo peso equivalente è la metà della massa molare.`)
};

const pt_br2_norm_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso equivalente é a massa molar dividida pela valência ou número de unidades reativas. O HCl fornece um próton, então seu peso equivalente é igual à sua massa molar (36,46); o H2SO4 fornece dois, então seu peso equivalente é metade da massa molar.`)
};

const pt_norm_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O equivalente-grama é a massa molar dividida pela valência ou número de unidades reativas. O HCl fornece um protão, pelo que o seu equivalente-grama é igual à sua massa molar (36,46); o H2SO4 fornece dois, pelo que o seu equivalente-grama é metade da sua massa molar.`)
};

const ja_norm_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当量は、モル質量を原子価または反応単位の数で割ったものです。HClはプロトンを1個供給するため、当量はモル質量 (36.46) に等しくなります。H2SO4はプロトンを2個供給するため、当量はモル質量の半分になります。`)
};

const zh_norm_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当量重量是摩尔质量除以化合价或反应单元数。HCl 提供一个质子，因此其当量重量等于其摩尔质量（36.46）；H2SO4 提供两个，因此其当量重量是摩尔质量的一半。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const norm_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.norm_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("norm_faq_a2", locale)
	if (locale === "en") return en_norm_faq_a2(inputs)
	if (locale === "es") return es_norm_faq_a2(inputs)
	if (locale === "de") return de_norm_faq_a2(inputs)
	if (locale === "nl") return nl_norm_faq_a2(inputs)
	if (locale === "fr") return fr_norm_faq_a2(inputs)
	if (locale === "it") return it_norm_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_norm_faq_a2(inputs)
	if (locale === "pt") return pt_norm_faq_a2(inputs)
	if (locale === "ja") return ja_norm_faq_a2(inputs)
	return zh_norm_faq_a2(inputs)
};